import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO } from "@/lib/content";
import { Footer } from "@/components/Footer";

export default function Privacy() {
  return (
    <main className="min-h-screen" data-testid="privacy-page">
      <div className="mx-auto max-w-3xl px-5 py-12 sm:px-8">
        <div className="flex items-center justify-between">
          <img src={LOGO} alt="Skin Lovers Professional" className="h-5 w-auto sm:h-6" />
          <Link to="/" className="btn-ghost !px-4 !py-2" data-testid="privacy-back-link"><ArrowLeft className="h-4 w-4" /> Torna al workshop</Link>
        </div>
        <h1 className="mt-16 text-5xl text-cream">Informativa privacy</h1>
        <p className="mt-4 text-sm text-sand">[Testo segnaposto: sostituire con l'informativa privacy definitiva di Skin Lovers]</p>
        <div className="mt-10 space-y-6 text-[15px] leading-relaxed text-sand">
          <p><b className="text-cream">Titolare del trattamento.</b> [Ragione sociale, indirizzo, P.IVA ed email di contatto del titolare del trattamento].</p>
          <p><b className="text-cream">Dati raccolti.</b> Nome e cognome, numero WhatsApp, dati del centro, dati di fatturazione ed email, inseriti nel modulo di iscrizione al workshop.</p>
          <p><b className="text-cream">Finalità.</b> Gestire l'iscrizione e il pagamento, emettere la fattura, inviare il link Zoom e i promemoria del workshop e, solo con consenso facoltativo, inviare novità e offerte Skin Lovers.</p>
          <p><b className="text-cream">Cookie.</b> Usiamo cookie tecnici necessari e, solo previo consenso, cookie di analisi e marketing (Meta Pixel, Google Analytics 4). Puoi modificare la scelta in ogni momento da "Preferenze cookie" nel footer.</p>
          <p><b className="text-cream">Diritti.</b> [Testo sui diritti dell'interessato ai sensi degli artt. 15-22 GDPR e modalità di esercizio].</p>
        </div>
      </div>
      <Footer />
    </main>
  );
}
